import compensationReducer  from './compensationSlice';
import compensationFilterReducer  from './compensationFilters';

const compensationReducers = {
    compensationReducer: compensationReducer,
    compensationFilters: compensationFilterReducer,
};

export default compensationReducers;